/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// SMA-185 Q6. Added by hand, like the other admin models the offline SDK export
// drops. The admin archive route returns this (archive-admin-group.dto.ts); a
// regen against a running API restores it.
export interface ArchiveAdminGroupResponse {
  archived: boolean;
}
